import { render, staticRenderFns } from "./BannerProduct.vue?vue&type=template&id=24a0f8ec&"
import script from "./BannerProduct.vue?vue&type=script&lang=js&"
export * from "./BannerProduct.vue?vue&type=script&lang=js&"
import style0 from "./BannerProduct.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports